import { useState } from 'react';
import './SubscriptionPlan.css';
import { useNavigate } from 'react-router-dom';

const SubscriptionPlan = () => {
    const navigate = useNavigate();
    const [activePlan, setActivePlan] = useState('Pro');
    return (
        <div className="Subscription">
            <div className='d-flex flex-column w-100' style={{gap: '16px'}}>
                <div className="subscription-heading-text w-100 text-center">Subscription Plans</div>
                <div className='d-flex flex-column w-100 text-center'>
                    <span className='text-center heading-span'>All accounts start on the Free plan. </span>
                    <span className='text-center heading-span'>You’ll only be asked to upgrade when you add more than 3 employees.</span>
                </div>
            </div>

            <div className="content">
                <div
                    className={`content-card ${activePlan === 'Basic' ? 'active' : ''}`}
                    onClick={() => setActivePlan('Basic')}
                >
                    <div className="text-content">
                        <span className="title">Free</span>
                        <span className="price">$0 Forever</span>
                        <p className="subtitle">Best for trying BrainyClock.</p>

                        <ul>
                            <li>ClockUp to 3 employees.</li>
                            <li>1 location.</li>
                            <li>Basic attendance tracking.</li>
                            <li>Get started in minutes.</li>
                        </ul>
                        <div className='d-flex flex-column gap-2'>
                            <button className="plan-btn" onClick={() => navigate('/signup')}>
                                Start free 
                            </button>
                            <span className='w-100 text-center' style={{ color: '#F0DFD7', fontSize: '11px',fontFamily:'Open Sans' }}>No credit card required</span>
                        </div>
                    </div>
                </div>

                <div
                    className={`content-card popular ${activePlan === 'Pro' ? 'active' : ''
                        }`}
                    onClick={() => setActivePlan('Pro')}
                >

                    <div className="text-content">
                        <div className='d-flex justify-content-between'>
                            <span className="title">Pro</span>
                            <div className="badge">Most Popular</div>
                        </div>
                        <span className="price">$3/employee/month</span>
                        <p className="subtitle">For growing teams.</p>

                        <ul>
                            <li>Add up to 1000 employees.</li>
                            <li>Multiple locations.</li>
                            <li>Wage & payroll-ready reports.</li>
                            <li>Full attendance history.</li>
                        </ul>

                        <button className="plan-btn" onClick={() => navigate('/signup')}>
                            Start free → Upgrade when ready
                        </button>
                    </div>
                </div>

                <div
                    className={`content-card ${activePlan === 'Enterprise' ? 'active' : ''
                        }`}
                    onClick={() => setActivePlan('Enterprise')}
                >
                    <div className="text-content">
                        <span className="title">Enterprise</span>
                        <span className="price">Custom pricing</span>
                        <p className="subtitle">
                            For large organizations.
                        </p>

                        <ul>
                            <li>1,000+ employees.</li>
                            <li>Advanced controls & support.</li>
                            <li>Custom requirements.</li>
                        </ul>

                        <button className="plan-btn">
                            Contact sales
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlan;
